window.onload = () => {
    removeBreakTags();
};
const removeBreakTags = () => {
    const breakTags = document.querySelectorAll('br');
    let breakTagFound = false;
    breakTags.forEach(br => {
        breakTagFound = true;
        br.remove();
    });
    if (breakTagFound) {
    } else {
    }
};
export default removeBreakTags;
